<template>
    <div>Pivot</div>
</template>

<script>
/* eslint-disable */
import store from "../../store/index";
import axios from 'axios';
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.toolbar.min.js";
import "webdatarocks/webdatarocks.js";
export default {
  name: "CohortPivot",
  props: {
    afterchartdraw: Function,
    aftergriddraw: Function,
    beforegriddraw: Function,
    beforetoolbarcreated: Function,
    cellclick: Function,
    celldoubleclick: Function,
    componentFolder: String,
    customizeCell: Function,
    customizeContextMenu: Function,
    datachanged: Function,
    dataerror: Function,
    datafilecancelled: Function,
    dataloaded: Function,
    fieldslistclose: Function,
    fieldslistopen: Function,
    filterclose: Function,
    filteropen: Function,
    fullscreen: Function,
    global: Object,
    height: [String, Number],
    loadingdata: Function,
    loadinglocalization: Function,
    loadingolapstructure: Function,
    loadingreportfile: Function,
    localizationerror: Function,
    localizationloaded: Function,
    olapstructureerror: Function,
    olapstructureloaded: Function,
    openingreportfile: Function,
    querycomplete: Function,
    queryerror: Function,
    ready: Function,
    report: [String, Object],
    reportchange: Function,
    reportcomplete: Function,
    reportfilecancelled: Function,
    reportfileerror: Function,
    reportfileloaded: Function,
    runningquery: Function,
    toolbar: Boolean,
    update: Function,
    width: [Number, String],
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      reportdata: [],
    }
  },
  mounted: function() {
    window.addEventListener("studyIdChanged", (event) => {
      this.reportfun();
    });
    this.reportfun();
    this.webdatarocks = new WebDataRocks({
      ...this.$props,
      container: this.$el,
      beforetoolbarcreated: this.customizeToolbar,
      report: {}
    });
  },
  beforeUpdate() {
    return false;
  },
  methods: {
    async reportfun(){
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
          .get(`${this.baseurl}/report/patient/subjectcohortsummary?StudyId=${currentstudy}`,
              {
                  headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                  },
              }
          )
          .then((res) => {
              this.reportdata = res.data;
              console.log("cohort report data recieved");
              console.log(res.data);
              // Preprocess data to prevent WebDataRocks from auto-detecting date fields as date hierarchies
              let processedData = res.data.map(item => {
                return {
                  ...item,
                  baselineEnrollmentDate: item.baselineEnrollmentDate ? String(item.baselineEnrollmentDate) : "",
                  screeningDate: item.screeningDate ? String(item.screeningDate) : "",
                  consentDate: item.consentDate ? String(item.consentDate) : ""
                };
              });
               processedData.unshift({
                    // cohortId: { type: "string" },
                    cohortName: { type: "string" },
                    cohortCode: { type: "string" },
                    totalSubjects: { type: "string" },
                    enrolledSubjects: { type: "string" },
                    screenFailureSubjects: { type: "string" },
                    withdrawnSubjects: { type: "string" },
                 });
              let setrept = {
                dataSource: {
                  data: processedData,
                  // mapping: {
                  //   "screeningDate": { type: "string" },
                  //   "consentDate": { type: "string" },
                  //   "baselineEnrollmentDate": { type: "string" }
                  // }
                },
                "options": {
                  "grid": {
                    "type": "flat",
                    "showGrandTotals": "off"
                  }
                },
                "slice": {
                  "rows": [
                    // {
                    //   "uniqueName": "cohortId"
                    // },
                    {
                      "uniqueName": "cohortName"
                    },
                    {
                      "uniqueName": "cohortCode"
                    },
                    {
                      "uniqueName": "totalSubjects"
                    },
                    {
                      "uniqueName": "enrolledSubjects"
                    },
                    {
                      "uniqueName": "screenFailureSubjects"
                    },
                    {
                      "uniqueName": "withdrawnSubjects"
                    }
                  ],
                  "columns": [
                    // {
                    //   "uniqueName": "cohortId",
                    //   caption: this.$t('navigations.cohort id')
                    // },
                    {
                      "uniqueName": "cohortName",
                      caption: this.$t('navigations.cohort Name')
                    },
                    {
                      "uniqueName": "cohortCode",
                      caption: this.$t('navigations.cohort code')
                    },
                    {
                      "uniqueName": "totalSubjects",
                      caption: this.$t('navigations.total Subjects')
                    },
                    {
                      "uniqueName": "enrolledSubjects",
                      caption: this.$t('navigations.enrolled subjects')
                    },
                    {
                      "uniqueName": "screenFailureSubjects",
                      caption: this.$t('navigations.screen Failure Subjects')
                    },
                    {
                      "uniqueName": "withdrawnSubjects",
                      caption: this.$t('navigations.withdrawn Subjects')
                    }
                  ],
                  "measures": [
                    // {
                    //   "uniqueName": "cohortId"
                    // },
                    {
                      "uniqueName": "cohortName"
                    },
                    {
                      "uniqueName": "cohortCode"
                    },
                    {
                      "uniqueName": "totalSubjects"
                    },
                    {
                      "uniqueName": "enrolledSubjects"
                    },
                    {
                      "uniqueName": "screenFailureSubjects"
                    },
                    {
                      "uniqueName": "withdrawnSubjects"
                    }
                  ]
                }
              }
              this.webdatarocks.setReport(setrept);
          }).catch((err) => {
             console.log(err);
          });
    },
    customizeToolbar(toolbar) {
        var tabs = toolbar.getTabs();
        toolbar.getTabs = function () {
           delete tabs[0]
           delete tabs[1]
            return tabs;
        }
    }
  }
};
</script>
<style scoped>
@import '~webdatarocks/webdatarocks.min.css';
</style>